
const notificationTypes = {
  INFO: "info",
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
};

export default class Notifier {
  #store;
  constructor(store) {
    this.#store = store;
  }

  info(text) {
    this.#store.dispatch("createNotification", {
      text,
      type: notificationTypes.INFO,
    });
  }

  success(text) {
    this.#store.dispatch("createNotification", {
      text,
      type: notificationTypes.SUCCESS,
    });
  }

  error(text) {
    this.#store.dispatch("createNotification", {
      text,
      type: notificationTypes.ERROR,
    });
  }

  warning(text) {
    this.#store.dispatch("createNotification", {
      text,
      type: notificationTypes.WARNING,
    });
  }
}